
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/request-tombo-api",
      function () {
        return require("private-next-pages/request-tombo-api/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/request-tombo-api"])
      });
    }
  